module.exports = __webpack_public_path__ + "static/toronto-50c4b84920367afed98c3127f2eb15d7.jpg";